<template>
  <div class="welcome">
    <Modal
      :active="modalActive"
      name="WelcomeModal"
      id="welcomeModal"
      :title="localizedText.title"
      :subtitle="localizedText.subtitleMarket"
      :img="imageMarket"
      :class="{ 'for-mobile-app': isMobileApp }"
      :closable="false"
      @close.prevent="$emit('close')"
    >
      <div class="welcome__container">
        <div class="welcome__content text-left">
          <div class="welcome__action">
            <div >
              <Button
                variant="primary"
                size="lg"
                mobile
                :wide="false"
                @click="localizedText.actionMarket.action()"
              >
                Продолжить
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import ImageMarket from '../../assets/img/welcome-modal/gold-c.png';

export default {
  name: 'WelcomeModal',
  props: {
    active: Boolean,
    localizedText: Object,
    isMobileApp: Boolean,
  },
  data() {
    return {
      modalActive: false,
      imageMarket: ImageMarket,
    };
  },
  watch: {
    active(val) {
      if (val) {
        this.createAnimation();
        setTimeout(() => { this.modalActive = true; }, 100);
      } else {
        this.modalActive = false;
      }
    },
  },
  methods: {
    createAnimation() {
      const modal = document.getElementById('welcomeModal');
      if (!modal) return;
      const imageContainer = modal.querySelector('.rr-modal__img');
      if (!imageContainer) return;
      const animContainer = imageContainer.querySelector('.animation');
      if (animContainer) return;
      const anim = document.createElement('div');
      anim.setAttribute('class', 'animation');
      const items = ['confetti', 'confetti two', 'confetti three', 'confetti four',
        'confetti--purple', 'confetti--purple two', 'confetti--purple three', 'confetti--purple four'];
      for (let i = 0; i < items.length; i += 1) {
        const item = document.createElement('div');
        item.setAttribute('class', items[i]);
        anim.appendChild(item);
      }
      imageContainer.appendChild(anim);
    },
  },
  mounted() {
    this.createAnimation();
  },
  beforeDestroy() {
    this.modalActive = false;
  },
};
</script>

<style lang="scss" scoped>
  @import './WelcomeModal';
</style>
